import React from "react";
import PropTypes from "prop-types";
import * as StyledDom from "./style.jsx";

function HorizontalTabs({
  activeTab,
  handleTabChange,
  tabNames,
  containerStyle,
  HorizontalTabContainerStyle,
  tabBackgroundColor,
  tabColor,
  tabBorderBottom,
  tabBorderRadius,
  tabstyle,
  customInactiveBorderBottom,
  customActiveClass,
}) {
  const handleChange = (index) => {
    handleTabChange(index);
  };

  return (
    <StyledDom.StyledHorizontalTabs
      className="Horizontal-tabs"
      style={HorizontalTabContainerStyle}
    >
      <StyledDom.StyledTabsList className="tabs-list" style={containerStyle}>
        {tabNames.map((tab, index) => (
          <StyledDom.StyledTab
            key={index}
            active={activeTab === index ? "active" : ""}
            onClick={() => handleChange(index)}
            backgroundColor={tabBackgroundColor}
            color={tabColor}
            style={{
              ...tabstyle,
              ...tab.style,
              boxShadow: "none",
            }}
            borderRadius={tabBorderRadius}
            className={activeTab === index ? customActiveClass : ""}
          >
            {/* {tab.icon && (
              <img
                src={tab.icon}
                alt={`${tab.name}-icon`}
                style={{
                  width: "20px",
                  height: "20px",
                }}
              />
            )} */}
            {tab.icon}
            {tab.name}
            {tab.number}
          </StyledDom.StyledTab>
        ))}
      </StyledDom.StyledTabsList>
    </StyledDom.StyledHorizontalTabs>
  );
}

HorizontalTabs.propTypes = {
  activeTab: PropTypes.number.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  tabNames: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
      iconSrc: PropTypes.string,
      number: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
      style: PropTypes.object,
    })
  ).isRequired,
  containerStyle: PropTypes.object,
  HorizontalTabContainerStyle: PropTypes.object,
  enableActiveBorderBottom: PropTypes.bool,
};

export default HorizontalTabs;
